import React from "react"
import styled from "styled-components"
import LogoIcon from "../icons/LogoIcon"
import LogoText from "../icons/LogoText"

interface Props {
	size: number
	textColor?: string
	responsive?: boolean
	monochrome?: boolean
	target?: React.HTMLAttributeAnchorTarget
	href?: string
}

const Logo: React.FC<Props> = ({ size, responsive, textColor, monochrome, href, ...props }) => {
	return (
		<LogoWrapper
			href={href || "https://busstock.app/"}
			target="_blank"
			rel="noopener noreferrer"
			{...props}
		>
			<ResponsiveLogoIcon
				size={size}
				responsive={responsive}
				color={monochrome ? "#000" : undefined}
			/>
			<ResponsiveLogoText
				size={size * 0.75}
				responsive={responsive}
				color={monochrome ? "#000" : textColor}
			/>
		</LogoWrapper>
	)
}

const LogoWrapper = styled.a`
	display: flex;
	align-items: center;
	justify-content: center;
`
const ResponsiveLogoIcon = styled(LogoIcon)<Props>`
	margin-right: ${(props) => props.size * 0.375}px;
	${(props) =>
		props.responsive &&
		`
		@media only screen and (max-width: 400px){
			display: none;
		}
	`}
`
const ResponsiveLogoText = styled(LogoText)<Props>`
	${(props) =>
		props.responsive &&
		`
		@media only screen and (max-width: 767px){
			display: none;
		}
	`}
`
Logo.defaultProps = {
	size: 40,
}

export default Logo
